export default __webpack_public_path__ + "static/media/zrak-geometrie.101e1fac.svg";